<template>
  <v-app>
    <v-app-bar
      v-if="isMobile && userDoc"
      absolute
      color="#EEEEEE"
      dark
      scroll-target="#scrolling-techniques-6"
    >
      <v-toolbar-title>
        <img style="width: 30%" class="mt-2" :src="logo" alt="" srcset="" />
      </v-toolbar-title>
      <v-spacer></v-spacer>
      <v-app-bar-nav-icon
        v-if="selectedApp"
        color="primary"
        @click="sideBar = !sideBar"
      />
      <i
        v-else
        @click="logOut"
        style="color: #008bbf !important; font-size: 20px !important"
        class="fas fa-sign-out-alt"
      ></i>
    </v-app-bar>

    <v-scale-transition v-if="sideBar" group leave-absolute mode="in-out">
      <v-navigation-drawer
        v-model="drawer"
        :mini-variant.sync="mini"
        width="320"
        app
        permanent
        dark
        color="#EEEEEE"
        key="app_nav"
        clipped
        v-if="navBar"
      >
        <div style="display: flex; justify-content: center; margin-top: 20px">
          <img
            style="width: 150px; cursor: pointer"
            @click="$router.push({ path: '/apps' })"
            :src="logo"
          />
        </div>
        <v-list dense style="background: transparent !important">
          <v-list-item class="mb-5" v-if="user">
            <v-list-item-content>
              <v-list-item-title
                @click="goToApps"
                class="subtitle-1 font-weight-bold"
                style="
                  cursor: pointer;
                  color: rgb(133 136 138);
                  text-align: center;
                "
              >
                <v-icon
                  style="
                    font-size: 15px !important;
                    color: rgb(133 136 138);
                    margin-bottom: 8px;
                  "
                >
                  fa-grip-vertical
                </v-icon>
                <span class="ml-3">Menú inicial</span>
              </v-list-item-title>
            </v-list-item-content>
          </v-list-item>

          <v-divider style="background-color: white" class="mb-3"></v-divider>
          <v-list-item
            v-for="(item, id) of items"
            :key="id"
            :to="`${item.link}`"
            @click="isMobile ? (sideBar = false) : ''"
            class="mb-5"
          >
            <v-list-item-icon>
              <v-icon
                class="mr-5"
                style="font-size: 20px !important; color: rgb(133 136 138)"
                large
                >{{ item.icon }}</v-icon
              >
            </v-list-item-icon>

            <v-list-item-content>
              <v-list-item-title
                style="font-size: 17px; color: rgb(133 136 138)"
                v-text="item.title"
              >
              </v-list-item-title>
            </v-list-item-content>
          </v-list-item>
        </v-list>

        <template v-slot:append>
          <div
            class="pa-2 pt-1"
            style="background-color: rgba(255, 255, 255, 0)"
          >
            <v-btn
              @click="logOut"
              color="btn-color"
              class="mb-1"
              style="padding: 14px !important; border-radius: 10px"
              block
              large
              :elevation="0"
            >
              <v-icon>fa-sign-out-alt</v-icon>
              <span v-if="!mini" class="ml-2 font-weight-bold">
                Cerrar Sesión
              </span>
            </v-btn>
          </div>
        </template>
      </v-navigation-drawer>
    </v-scale-transition>

    <v-content :style="isMobile ? 'margin-top:10vh' : ''">
      <div v-if="$store.state.group" class="statistics">
        <i class="fas fa-layer-group"></i>
        <span class="mr-5 ml-3 font-weight-bold">{{ groupName }} </span>
        <!-- <i class="fas fa-database mr-3"></i>
        <span>{{ usedSpace }}/{{ totalStorage }}</span> -->
      </div>
      <transition-page class="mt-5">
        <router-view v-if="!loading" />
      </transition-page>
    </v-content>

    <v-footer app padless fixed color="#008BBF" dark>
      <v-col class="text-left caption" cols="2">
        <span> v{{ version }} </span>
      </v-col>
      <v-col class="text-center caption" cols="8" v-if="!isMobile">
        powered by:
        <b>
          <a class="white--text" href="http://beanar.io" target="_blank"
            >Beanario Software</a
          >
        </b>
        <span>, &#169; 2021,</span>
        <span class="font-weight-bold">Wink</span>
      </v-col>
    </v-footer>

    <v-snackbar absolute top :timeout="3000" v-model="snackbar">
      {{ snackbarText }}
    </v-snackbar>

    <v-dialog
      persistent
      max-width="400px"
      v-if="tokenDialog"
      v-model="tokenDialog"
    >
      <token-input
        ref="tokenComponent"
        @cancel="tokenDialog = false"
        @insertedToken="verifyToken"
      />
    </v-dialog>
  </v-app>
</template>

<script>
import mobile from "is-mobile";
import { db, fb } from "@/firebase";
import { mapState, mapActions } from "vuex";
import TransitionPage from "./components/TransitionPage";
import tokenInput from "./components/tokenInput";

export default {
  name: "App",
  components: {
    TransitionPage,
    tokenInput,
  },
  data: () => ({
    version: "0.0.1",
    drawer: null,
    mini: false,
    sideBar: false,
    userSnapshot: "",
    logo: require("@/assets/wink-logo.svg"),
    group: null,
    loading: true,
    snackbar: false,
    snackbarText: null,
    tokenDialog: false,
    itemsGeneral: [
      {
        icon: "fa-user",
        title: "Información de Cuenta",
        link: "/profile",
        disabled: false,
      },
      // {
      //   icon: "fa-users",
      //   title: "Usuarios",
      //   link: "/users",
      //   disabled: false,
      // },
      {
        icon: "fa-images",
        title: "Imágenes",
        link: "/images",
        disabled: false,
      },
      {
        icon: "fa-video",
        title: "Videos",
        link: "/videos",
        disabled: false,
      },
      {
        icon: "fa-play-circle",
        title: "Listas de Reproducción",
        link: "/playlists",
        disabled: false,
      },
    ],
    roleLabels: {
      player: {
        name: "Digital Signage",
        menu: [
          {
            icon: "fa-building",
            title: "Sucursales",
            link: "/agency",
            disabled: false,
          },
          {
            icon: "fa-desktop",
            title: "Pantallas",
            link: "/screens",
            disabled: false,
          },
        ],
      },
      directories: {
        name: "Directorios digitales",
        menu: [
          {
            icon: "fa-clipboard-list",
            title: "Categorías",
            link: "/categories",
            disabled: false,
          },
          {
            icon: "fa-list",
            title: "Características",
            link: "/characteristics",
            disabled: false,
          },
          {
            icon: "fa-sitemap",
            title: "Productos",
            link: "/products",
            disabled: false,
          },

          {
            icon: "fa-bookmark",
            title: "Banners",
            link: "/directories/banners",
            disabled: false,
          },
          {
            icon: "fa-building",
            title: "Sucursales",
            link: "/directories/agencies",
            disabled: false,
          },
          {
            icon: "fa-desktop",
            title: "Pantallas",
            link: "/directories/screens",
            disabled: false,
          },
        ],
      },
      zones: {
        name: "Multizonas",
        menu: [
          {
            icon: "fa-columns",
            title: "Zonas",
            link: "/zones",
            disabled: false,
          },
          {
            icon: "fa-desktop",
            title: "Pantallas",
            link: "/multizone/screens",
            disabled: false,
          },
        ],
      },
    },
  }),

  watch: {
    userSnapshot(user) {
      this.$store.state.userDoc = user;

      if (user.hasOwnProperty("active") && !user.active) this.logOut();
    },
    group(data) {
      this.$store.state.group = data[0];
    },
  },

  computed: {
    ...mapState(["selectedApp", "user", "userDoc"]),
    usedSpace() {
      return this.$store.state.group.usedStorage
        ? this.$store.state.group.usedStorage.toFixed(2)
        : 0;
    },
    totalStorage() {
      return this.$store.state.group.storage
        ? `${this.$store.state.group.storage} MB`
        : "";
    },
    groupName() {
      return this.$store.state.group.name
        ? `Grupo de ${this.$store.state.group.name}`
        : "nombre del grupo";
    },
    items() {
      let menu = [];
      if (this.selectedApp) {
        menu = [
          ...this.itemsGeneral,
          ...this.roleLabels[this.selectedApp].menu,
        ];
      } else {
        menu = [];
      }
      return menu;
    },
    appFrame() {
      return this.$store.state.appFrame;
    },
    navBar() {
      return this.$store.state.navBar;
    },
    isMobile() {
      return mobile();
    },
  },
  mounted() {
    if (!this.isMobile) {
      this.sideBar = true;
    }
    fb.auth().onAuthStateChanged(async (authUser) => {
      if (authUser) {
        await this.$binding(
          "group",
          db.collection("groups").where("users", "array-contains", authUser.uid)
        );

        if (this.group && this.group.length == 0) {
          this.snackbarText = "El usuario no se ha vinculado a ningún grupo.";
          this.snackbar = true;
          this.logOut();
          location.reload();
        } else {
          await this.$binding(
            "userSnapshot",
            db.collection("users").doc(authUser.uid)
          );

          this.$store.state.group = this.group[0];
          this.$store.state.groupId = this.group[0][".key"];

          this.$router.push({ path: "/apps" }).catch((err) => {
            err;
          });
          this.$store.state.user = authUser;
          this.loading = false;
        }
      } else {
        this.loading = false;
        if (this.$router.history.current.fullPath != "/login")
          this.$router.push({ path: "/login" });
      }
    });
  },

  methods: {
    ...mapActions(["addApp"]),
    logOut() {
      if (this.user) {
        fb.auth()
          .signOut()
          .then(() => {
            this.$store.state.selectedApp = "";
          })
          .catch(function (error) {});
      }
    },
    goToApps() {
      if (this.$router.history.current.fullPath != "/apps")
        this.$router.push({ path: "/apps" });
    },
  },
};
</script>

<style src="./assets/css/animate.css"></style>


<style lang="scss">
@import "~@/assets/scss/brands.scss";
@import "~@/assets/scss/fontawesome.scss";
@import "~@/assets/scss/light.scss";
@import "~@/assets/scss/regular.scss";
@import "~@/assets/scss/solid.scss";

@font-face {
  font-family: "nexa";
  src: url("~@/assets/fonts/nexa_regular-webfont.woff2") format("woff2");
  font-weight: normal;
  font-style: normal;
}

@font-face {
  font-family: "nexa";
  src: url("~@/assets/fonts/nexa_light-webfont.woff2") format("woff2");
  font-weight: 100;
  font-style: normal;
}

@font-face {
  font-family: "nexa";
  src: url("~@/assets/fonts/nexa_bold-webfont.woff2") format("woff2");
  font-weight: bold;
  font-style: normal;
}

html {
  -webkit-touch-callout: none;
  -webkit-user-select: none;
}

body .v-application {
  font-family: "nexa" !important;
}

body .v-application {
  .display-1,
  .display-2,
  .display-3,
  .display-4,
  .headline,
  .title,
  .subtitle-1,
  .subtitle-2,
  .body-1,
  .body-2,
  .caption,
  .overline {
    font-family: "nexa" !important;
  }
}

.v-card__title {
  word-break: normal !important;
}

.cardBox {
  background-color: white;
  // border-radius: 35px;
  padding: 8px 4px !important;
  flex-grow: 0 !important;
  width: 100%;
  // min-width: calc(100vw - 24px);
}

.v-dialog {
  border-radius: 35px !important;
}
// .v-card {
//   border-radius: 35px !important;
//   white-space: pre-wrap;
// }

.v-snack__wrapper {
  border-radius: 35px !important;
  background-color: rgba(0, 0, 0, 0.9) !important;
}

.v-btn--rounded {
  // border-radius: 10px !important;
  font-weight: bold !important;
  text-transform: unset !important;
}

.disclaimer-text {
  font-size: 14px;
  font-weight: 500;

  span {
    display: inline-block;
    line-height: 13px;
    font-weight: normal;
    font-size: 12px;
  }
}

body
  .v-application
  .v-text-field--rounded
  > .v-input__control
  > .v-input__slot {
  border-radius: 10px !important;
  padding: 0 14px !important;
}

input::-webkit-inner-spin-button,
input::-webkit-outer-spin-button {
  -webkit-appearance: none;
  margin: 0;
}

input:-webkit-autofill,
input:-webkit-autofill:hover,
input:-webkit-autofill:focus,
textarea:-webkit-autofill,
textarea:-webkit-autofill:hover,
textarea:-webkit-autofill:focus,
select:-webkit-autofill,
select:-webkit-autofill:hover,
select:-webkit-autofill:focus {
  border: none;
  // -webkit-text-fill-color: #644f97;
  box-shadow: none;
  -webkit-box-shadow: none;
  // color: white;
  transition: background-color 5000s ease-in-out 0s;
}

.v-data-table tbody tr.v-data-table__expanded__content {
  -webkit-box-shadow: none !important;
  box-shadow: none !important;
}

.v-input__append-inner {
  margin-right: 10px;
}

.v-navigation-drawer__border {
  display: none;
}

.v-application--is-ltr .v-list-item__action:first-child,
.v-application--is-ltr .v-list-item__icon:first-child {
  margin-right: 6px !important;
}

.v-icon.v-icon {
  font-size: 16px !important;
}

.titleBasa svg {
  position: relative;
  height: 32px;
  top: 2px;
  // margin-right: 5px;
  display: inline-block;
}

.v-list-item__avatar {
  margin-bottom: 5px !important;
  margin-top: 5px !important;
}

.v-date-picker-table .v-btn {
  border-radius: 28px !important;
}

.v-picker__actions.v-card__actions .row.no-gutters {
  padding: 0 10px;
}

.v-tooltip__content {
  background-color: rgba(0, 0, 0, 0.9) !important;
  border-radius: 25px !important;
}

.v-data-table-header__icon {
  margin: 0 4px !important;
  // color: #644f97 !important;
}

body
  .v-application
  .v-text-field--rounded
  > .v-input__control
  > .v-input__slot {
  border-radius: 60px !important;
}
.v-autocomplete__content.v-menu__content {
  border-radius: 17px !important;
}

.v-list-item--disabled {
  opacity: 0.3 !important;
}

.v-list-item--disabled .v-avatar.v-list-item__avatar img {
  opacity: 0.8 !important;
  filter: grayscale(100%);
}

.theme--light.v-list {
  background: #e6e6e6 !important;
}
.theme--dark.v-list {
  background: #111111 !important;
}

.v-snack__content {
  justify-content: center !important;
}

.submenu-items {
  width: 100%;
  // margin-top: 20%;
}

.logo-menu {
  border-radius: 30px;
  width: 30px;
  height: 30px;
  margin-left: -10px;
  margin-right: 10px;
}

::-webkit-scrollbar {
  width: 10px;
  height: 10px;
}

::-webkit-scrollbar-track {
  box-shadow: inset 0 0 5px rgb(83, 83, 83);
  border-radius: 10px;
}

::-webkit-scrollbar-thumb {
  background: rgb(83, 83, 83) !important;
  border-radius: 10px;
}

.v-list--rounded .v-list-item,
.v-list--rounded .v-list-item::before,
.v-list--rounded .v-list-item > .v-ripple__container {
  border-radius: 10px !important;
  display: flex;
  justify-content: center;
}

.control-input {
  border: 1px solid rgba(90, 89, 89, 0.315);
  border-radius: 50px;
  width: 100%;
  padding: 10px;
  margin-top: 10px;
  color: black;
}

.control-input-number {
  border: 1px solid rgba(90, 89, 89, 0.315);
  border-radius: 50px;
  width: 100% !important;
  padding: 10px;
  margin-top: 10px;
}

.control-input:focus {
  outline: none !important;
  // border: 1px solid #644f97;
  // box-shadow: 0 0 5px #644f97;
}

.sticky {
  position: fixed !important;
  top: 65px !important;
  z-index: 2 !important;
  transition: visibility 0s, opacity 0.2s linear;
}

.v-btn .v-btn__content {
  text-transform: initial !important;
}

.screen-width {
  width: 80% !important;
}

.main-container {
  width: 100%;
  justify-content: center;
}

@media only screen and (max-width: 600px) {
  .v-card__text {
    padding: 0 !important;
  }

  .container {
    padding: 0 !important;
  }

  .screen-width {
    width: 100% !important;
  }
}

textarea {
  padding-left: 20px !important;
}

.save-btn {
  border-radius: 50px !important;
  color: white !important;
}

// .v-btn .v-btn__content {
//   color: white!important;
// }

.theme--light.v-btn:not(.v-btn--flat):not(.v-btn--text):not(.v-btn--outlined) {
  border-radius: 10px !important;
}

.v-list-item--link {
  border-radius: 50px;
}

.v-card {
  border-radius: 15px !important;
}

.v-dialog {
  border-radius: 15px !important;
}

label,
h3,
p {
  color: black;
}

.leaflet-control-geosearch form input {
  padding: 17px !important;
  font-weight: bold;
}

.leaflet-control-geosearch a.reset {
  // color: #644f97 !important;
  font-weight: bold;
  font-size: 15px;
  margin-top: 5px;
}

.v-text-field--filled > .v-input__control > .v-input__slot,
.v-text-field--full-width > .v-input__control > .v-input__slot,
.v-text-field--outlined > .v-input__control > .v-input__slot {
  min-height: 45px !important;
}

.v-select.v-select--chips:not(.v-text-field--single-line).v-text-field--box
  .v-select__selections,
.v-select.v-select--chips:not(.v-text-field--single-line).v-text-field--enclosed
  .v-select__selections {
  min-height: 50px !important;
}

.business-active {
  margin-left: -10px;
}

.page-title {
  color: #515151;
}
.title-hr {
  width: 95%;
  // color: #fff5f54f;
  height: 0.3px;
  background-color: white;
}

.video-card-actions {
  display: flex !important;
  // grid-template-columns: 50% 50%;
  align-items: center;
  justify-content: space-around;
  // grid-template-columns: 36% 40% 33%;
}

.two-card-actions {
  display: flex !important;
  grid-template-columns: 50% 50%;
  align-items: center;
  justify-content: space-around;
}

.v-btn--fab.v-size--large {
  bottom: 20px;
  position: fixed;
  right: 20px;
}

.nowrap-text {
  white-space: nowrap;
  overflow: hidden;
  max-width: 95%;
  text-overflow: ellipsis;
}
input[type="color"] {
  height: 30px !important;
  min-height: 30px !important;
  max-height: 30px !important;
}
.error-validation {
  color: rgb(107, 0, 0);
  position: relative;
  top: -20px;
}

body
  .v-application
  .v-text-field--rounded
  > .v-input__control
  > .v-input__slot {
  border-radius: 10px !important;
}

.statistics {
  position: absolute;
  color: gray;
  right: 20px;
  top: 20px;
}

.theme--light.v-data-table
  .v-data-table-header
  th.sortable.active
  .v-data-table-header__icon {
  color: #008bbf !important;
}

.btn-color {
  color: white !important;
}

// button[type=button] {
//   // background-color: #00D2EA!important;
// }

.v-list-item--active {
  color: #515151 !important;
}
</style>
